module.exports = __webpack_public_path__ + "ae081748ed89a3f6c9e638aedc2c5df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2006_teaser_image.jpg
// module id = 556
// module chunks = 0